import React, { useEffect, useState, useRef } from "react";
import { CircularProgress, Box, Typography  } from "@mui/material";
import FindListItem from "./FindListItem";
import { supabase } from "../supabaseClient";

const FindWishList = ({userId}) => {
    const [places, setPlaces] = useState([]);
    const [loading, setLoading] = useState(true);
    const isMounted = useRef(false); // 언마운트 여부 체크용 ref

    useEffect(() => {
        if (!userId || isMounted.current) return;
        isMounted.current = true;
        setLoading(true);

        const fetchWishList = async () => {
            try {
                let query = supabase
                .from("wishlist")
                .select("place_id, places(*)") // ✅ places 테이블 데이터 포함
                .eq("user_id", userId)

                const { data, error } = await query;
                if (error) throw error;

                if (isMounted.current) {
                    setLoading(false);
                    setPlaces((data || []).map(item => item.places));
                }
            } catch (error) {
                console.error("위시리스트 불러오기 실패:", error.message);
            }
        };

        fetchWishList();
        return () => {
            isMounted.current = true;
        };
    }, [userId]); // ✅ user.id 변경 시 한 번만 실행

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
                <CircularProgress />
            </Box>
        );
    }
    return (
        <Box sx={{ mt: 3 }}>
            <Box sx={{display:'flex', gap:1, justifyContent:"space-between", mb:1}}>
                <Typography>위시리스트 등록 갯수 : {places.length}</Typography>
            </Box>
            {places.length > 0 ? places.map((place, index) => {
                return <FindListItem key={index} {...place} userId={userId} />;
            }) : (
                <Typography textAlign="center">데이터가 없습니다.</Typography>
            )}
        </Box>
    );
    
};

export default FindWishList;
